// 网速
let speedInterval = null
// 
let networkInternet = null
//
let reNetWorkInternet = null
//网络连接状态
// let getConnectStatus = null
let time = 5000
let that = null
export function TestInternet (data) {
    that = data
	startNetwork()
    startSpeed()
}
export function stopTest () {
	endNetwork()
	endSpeed()
}
 
 
function getConnectStatus() {
	return window.navigator.onLine? 1 : 0
}
 
function disconnet() {
	window.clearInterval(reNetWorkInternet)
    that.$store.dispatch('setNetwork',-1)
	reNetWorkInternet = null
	window.setTimeout(() => {
		// 设置定时器
		reNetWorkInternet = window.setInterval(() => {
			if (getConnectStatus() == 1) {
			} else {
				disconnet()
			}
		}, time)
	}, 2 * time)
}
 
const speed = {
	/**
	 * 网速过慢
	 */
	bad : function(){
	 window.setTimeout(function(){
		if(getConnectStatus() === 1) {
		 window.clearInterval(networkInternet)
		 networkInternet = null
		 startSpeed()
		} else {
		 disconnect()
		}
	 }, 2 * time)
	},
	/**
	 * 网速中等
	 */
	medium : function(){
    //  this.$store.commit('setNetwork',1)
	},
	/**
	 * 网速极佳
	 */
	great : function(){
	//  console.log("网速极佳")
	}
}
 
// 开始测速
function startSpeed () {
	// 调用清楚定时器
	window.clearInterval(speedInterval)
	speedInterval = null;
	if (getConnectStatus() === 1) {
		speedInterval = window.setInterval( () => {
			let start = new Date().getTime()
			if (getConnectStatus() === 1) {
				let img = document.getElementById('networkSpeedImg')
				// 使用一个不展示的图片加载进行网速检测
				if (!!!img) {
					img = document.createElement('IMG')
					img.id = 'networkSpeedImg'
					img.style.display = 'none'
					document.body.appendChild(img)
				}
				try {
					img.src = 'https://www.guanmini.com/other/NetworkTestPic.png?t=' + new Date().getTime()
					img.onload = function() {
						let end = new Date().getTime()
						let delta = end - start
						that.$store.dispatch('setNetwork',delta)
						if (delta > 200) {
							speed.bad()
						} else if (delta > 100) {
							speed.medium()
						} else {
							speed.great()
						}
					}
				} catch ( e ) {
					speed.bad()
				}
			} else {
				disconnet()
			}
		}, time)
	} else {
		disconnet()
	}
}
 
// 停止测速
function endSpeed () {
	window.clearInterval(speedInterval);
  speedInterval = null;
}
 
// 开启网络连接监测
function startNetwork () {
	if (networkInternet) {
		window.clearInterval(networkInternet)
		networkInternet = null
	}
	if (getConnectStatus() === 1) {
		networkInternet = window.setInterval(() => {
			if (getConnectStatus() === 0) {
				disconnet()
			}
		}, time)
	} else {
		disconnet()
	}
}
 
// 结束网络连接监测
function endNetwork () {
	window.clearInterval(networkInternet)
	networkInternet = null
}
